module.exports = __webpack_public_path__ + "img/Cards.74fad248.svg";